import React from 'react'
import { Controller, Control, FieldErrors } from 'react-hook-form'
import BaseQuestion from '../base-question'
import s from '../styles.module.css'

interface LongTextQuestionProps {
  question: {
    id: number
    text: string
    isRequired?: boolean
    type: string
  }
  // RHF mode
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  value?: string
  error?: string
  onChange?: (value: string) => void
  onBlur?: () => void
}

const LongTextQuestion: React.FC<LongTextQuestionProps> = ({
  question,
  control,
  errors,
  value,
  error,
  onChange,
  onBlur,
}) => {
  const isRHFMode = !!control && !!errors

  if (isRHFMode) {
    // RHF mode - use Controller
    return (
      <BaseQuestion question={question} control={control} errors={errors}>
        <Controller
          name={`question_${question.id}`}
          control={control}
          rules={{
            required: question.isRequired ? 'This field is required' : false,
          }}
          render={({ field }) => (
            <textarea
              className={s.textareaInput}
              placeholder="Enter your response here..."
              rows={4}
              {...field}
            />
          )}
        />
      </BaseQuestion>
    )
  } else {
    // Zustand mode - use direct props
    return (
      <BaseQuestion question={question} error={error}>
        <textarea
          className={s.textareaInput}
          placeholder="Enter your response here..."
          rows={4}
          value={value || ''}
          onChange={e => onChange?.(e.target.value)}
          onBlur={onBlur}
        />
      </BaseQuestion>
    )
  }
}

export default LongTextQuestion
